/**
 * The storefront's payment-method classification, mirroring the backend's
 * ``is_card`` / ``is_payroll`` pair in ``order_money.py`` (#4187,
 * Jake 2026-10-08).
 *
 * ``is_card`` iff the card method; ``is_payroll`` iff the EXPLICIT payroll
 * method. Anything else -- "Accept Shopper Payments" OFF (empty or NULL
 * ``payment_method``), a typo, a value written through the API, the legacy
 * "Payroll Deduction" -- is NEITHER: no card, no payroll, and checkout
 * refuses it outright (``account._validate_checkout_store_takes_payment``,
 * PAYMENTS_OFF_MESSAGE).
 *
 * Before this, StorefrontCart.vue derived its own ``isPayroll`` as
 * ``payment_method !== "Individual CC Payment"``, so a payments-off store
 * read as payroll and CartCheckout.vue's allowance notice told the shopper
 * their balance would be "deducted from payroll as determined by your
 * program administrator" -- on a store that cannot take the order at all.
 */

export const CARD_PAYMENT_METHOD = "Individual CC Payment";
export const PAYROLL_PAYMENT_METHOD = "Invoice / Payroll Deductions";

/**
 * @param {string|null|undefined} paymentMethod
 * @returns {boolean} true iff the explicit payroll method.
 */
export function isPayrollPaymentMethod(paymentMethod) {
  return paymentMethod === PAYROLL_PAYMENT_METHOD;
}

/**
 * @param {string|null|undefined} paymentMethod
 * @returns {boolean} true iff the card method.
 */
export function isCardPaymentMethod(paymentMethod) {
  return paymentMethod === CARD_PAYMENT_METHOD;
}
